<template>
  <fieldset>
    <span class="label">{{label}}</span>

    <label v-if="!photo.data" class="shoot" title="Prendre une photo">
      <i class="icon icon-photo"></i>
      <input class="input" type="file" accept="image/*" @change="getPhoto">
    </label>

    <span v-if="photo.data" class="preview">
      <button class="cancel" v-if="photo.data" title="Annuler" @click="cancel" type="button">
        <svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4.151 17.943l-4.143-4.102-4.117 4.159-1.833-1.833 4.104-4.157-4.162-4.119 1.833-1.833 4.155 4.102 4.106-4.16 1.849 1.849-4.1 4.141 4.157 4.104-1.849 1.849z"/></svg>
      </button>
      <img class="pic" :src="photo.data">
    </span>
  </fieldset>
</template>

<script>
  export default {
    props: ['name', 'label', 'photo'],
    methods: {
      cancel() {
        this.$store.dispatch('removePhoto', {name: this.name})
      },
      getPhoto(event) {
        if(!event.target.files.length) return
        const photo = event.target.files[0]
        this.$store.dispatch('savePhoto', {
          name: this.name,
          photo
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/_vars.scss';

  fieldset {
    appearance: none;
    padding: 0;
    border: none;
    margin: spacer();
    position: relative;
    z-index: 0;
    padding-bottom: spacer();
    border-bottom: 1px solid rgba(black,.1);

    @include media('>tablet') {
      display: inline-block;
      width: calc(50% - #{$spacer*2});
      vertical-align: top;
    }
  }

  .shoot {
    display: block;
    appearance: none;
    background: none;
    border: none;
    width: 100%;
    padding: 0;
    min-height: 160px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .icon {
      margin: auto;
      font-size: 4em;
      text-align: center;
    }

    &:focus {
      outline: none;
    }
  }

  .label {
    width: 100%;
    font-size: .9em;
    margin-top: 0;
    margin-right: auto;
    text-align: left;
    color: color('secondaryBlue');
  }

  .cancel {
    display: flex;
    appearance: none;
    padding: 0;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    border: 2px solid white;
    background-color: white;
    margin: spacer(-.5);
    border-radius: 999px;
  }

  .input {
    width: 0;
    visibility: hidden;
    position: absolute;
  }

  .preview {
    display: block;
    background-color: white;
    position: relative;
    z-index: 0;

    img {
      display: block;
      border-radius: 5px;
      overflow: hidden;
    }
  }

  .pic {
    width: 100%;
    max-height: 50vh;
    object-fit: contain;
    margin: auto;
    background-color: color('background');
    border-radius: 5px;
    animation: appear 500ms 1 both;

    @keyframes appear {
      from { opacity: 0; }
      to   { opacity: 1; }
    }
  }
</style>
